"use client"

import * as React from 'react'
import { useRouter } from 'next/navigation'
import { Page, PageBody } from '@open-mercato/ui/backend/Page'
import { flash } from '@open-mercato/ui/backend/FlashMessages'
import { createCrud } from '@open-mercato/ui/backend/utils/crud'
import { useT } from '@open-mercato/shared/lib/i18n/context'
import { LocationCrudForm, buildLocationPayload, type LocationFormValues } from '../../../components/LocationCrudForm'

export default function LocationsCreatePage() {
  const t = useT()
  const router = useRouter()

  const handleSubmit = React.useCallback(async (values: LocationFormValues) => {
    const payload = buildLocationPayload(values, t)
    const { result } = await createCrud<{ id?: string }>('freight/locations', payload, {
      errorMessage: t('locations.errors.create', 'Failed to create location.'),
    })
    flash(t('locations.messages.created', 'Location created.'), 'success')
    const locationId = typeof result?.id === 'string' ? result.id : null
    if (locationId) {
      router.push(`/backend/locations/${encodeURIComponent(locationId)}`)
      return
    }
    router.push('/backend/locations')
  }, [router, t])

  return (
    <Page>
      <PageBody>
        <LocationCrudForm
          title={t('locations.form.createTitle', 'Create location')}
          submitLabel={t('locations.form.actions.create', 'Create')}
          backHref="/backend/locations"
          cancelHref="/backend/locations"
          initialValues={{
            name: '',
            code: '',
            type: '',
            unlocode: '',
            addressStreet: '',
            addressCity: '',
            addressPostalCode: '',
            addressCountry: 'PL',
            addressRegion: '',
            supportedModes: ['ROAD'],
            capabilities: [],
            gateInstructions: '',
            operatingHoursJson: '',
            slotBookingEnabled: false,
            isActive: true,
          }}
          onSubmit={handleSubmit}
        />
      </PageBody>
    </Page>
  )
}
